export const sortBrands = (brands, direction = 'asc') => {
	if (!Array.isArray(brands)) return [];
	const sorted = [...brands].sort((a, b) =>
		(a?.name || '').localeCompare(b?.name || '')
	);
	return direction === 'desc' ? sorted.reverse() : sorted;
};

export const sortMessagesByDate = (messages, direction = 'desc') => {
	if (!Array.isArray(messages)) return [];
	const sorted = [...messages].sort((a, b) => {
		const aMs = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
		const bMs = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
		return aMs - bMs;
	});
	return direction === 'desc' ? sorted.reverse() : sorted;
};
